module.exports = __webpack_public_path__ + "img/cptgb-4-en.cebd6e91.png";